import tippy, { Placement, Instance } from 'tippy.js'

import { useState } from '@/core'

import { constants } from './tooltip.constant'
import { tooltipSelectors } from './tooltip.selector'

export const TooltipComponent = (() => {
	const { state, setState } = useState({ tooltips: [] as Instance[] })

	const setTooltipInstance = (target: HTMLElement) => {
		if (!target.getAttribute(constants.selector.target)) return
		setState({
			tooltips: [
				...state.tooltips,
				tippy(target, {
					content: target.getAttribute(constants.selector.target) || '',
					placement: (target.getAttribute(constants.selector.placement) as Placement) || 'top',
					theme: 'dark',
					allowHTML: true,
				}),
			],
		})
	}

	const destroy = () => {
		for (let i = 0, { length } = state.tooltips; i < length; i++) {
			state.tooltips[i].destroy()
		}
	}

	const initTargets = () => {
		const targets = tooltipSelectors.getTargets()
		for (let i = 0, { length } = targets; i < length; i++) {
			setTooltipInstance(targets[i])
		}
	}

	const init = () => {
		initTargets()
	}

	return {
		init,
		destroy,
	}
})()
